<template>
    <div
        class="skill-tree"
        v-if="loaded">
        <b-tabs
            class="skill-tree-tab apprentice-tab"
            content-class="skill-tree-tab-content">
            <b-tab
                title="Sets"
                active
                title-item-class="skill-management-set-tab">
                <div class="apprentice-simple-card skills-set-management">
                    <design-2021-apprentice-data-table
                        v-if="skillTrees.length"
                        :items="skillTrees"
                        :fields="fields">
                        <template v-slot:options>
                            <b-button
                                class="btn-add btn-add-skill-tree"
                                v-b-modal="'add-skilltree'"
                                variant="primary">
                                {{ $t('skill_tree.new_set') }}
                            </b-button>
                        </template>

                        <template v-slot:cell(id)="data">
                            <div>{{ data.item.id }}</div>
                        </template>

                        <template v-slot:cell(active)="data">
                            <div>
                                <b-form-checkbox
                                    :checked="data.item.active"
                                    value="1"
                                    unchecked-value="0"
                                    @change="changeActive(data.item, $event)"
                                    switch>
                                </b-form-checkbox>
                            </div>
                        </template>

                        <template v-slot:cell(actions)="data">
                            <div class="actions">
                                <b-button
                                    class="btn-edit btn-edit-skill-tree remove-icon-margin"
                                    v-b-modal="'update-skill-tree-' + data.item.id"
                                    v-b-tooltip.hover
                                    variant="primary-icon-only"
                                    :title="$t('skill_tree.edit_set_skills')">
                                </b-button>

                                <b-button
                                    class="btn-open btn-show-skill-tree remove-icon-margin"
                                    v-b-tooltip.hover
                                    variant="primary-icon-only"
                                    @click="showSkillTree(data.item.id)"
                                    :title="$t('skill_tree.view_set_skills')">
                                </b-button>

                                <b-button
                                    class="btn-remove btn-remove-skill-tree remove-icon-margin"
                                    v-b-tooltip.hover
                                    variant="danger-icon-only"
                                    @click="deleteSkillTree(data.item.id)"
                                    :title="$t('skill_tree.delete_set_skills')">
                                </b-button>

                                <design-2021-skilltree-update-modal-component
                                    :las-groups-in="lasGroupsIn"
                                    :las-main-groups-in="lasMainGroupsIn"
                                    :skill-tree-in="data.item">
                                </design-2021-skilltree-update-modal-component>
                            </div>
                        </template>
                    </design-2021-apprentice-data-table>

                    <div
                        class="not-found with-header skill-tree-list-empty"
                        v-else>
                        <div class="header">
                            <b-button
                                class="btn-add btn-add-skill-tree"
                                v-b-modal="'add-skilltree'"
                                variant="primary">
                                {{ $t('skill_tree.new_set') }}
                            </b-button>
                        </div>
                        <div
                            class="btn-add-circle icon"
                            v-b-modal="'add-skilltree'"></div>
                        <div class="alert-notice">{{ $t('skill_tree.no_skill_sets_were_found') }}</div>
                    </div>
                    <design-2021-skilltree-add-modal-component
                        :las-main-groups-in="lasMainGroupsIn"
                        :las-groups-in="lasGroupsIn">
                    </design-2021-skilltree-add-modal-component>
                </div>
            </b-tab>

            <b-tab
                :title="$t('skill_tree.administrators')"
                title-item-class="skill-management-tab">
                <design-2021-skill-management-component :teachers-in="teachersIn">
                </design-2021-skill-management-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { ords } from '../../app';

const skillTreeOrds = ords.use('skillTree');
const skillOrds = ords.use('skill');

export default {
    name: 'design-2021-skill-index-component',
    props: ['lasGroupsIn', 'lasMainGroupsIn', 'skillTreesIn', 'teachersIn'],
    data() {
        return {
            skillTrees: [],
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.title'),
                    sortable: true,
                },
                {
                    key: 'active',
                    label: this.$t('skill_tree.active'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            loaded: false,
        };
    },
    methods: {
        changeActive(skillTree, event) {
            let data = {
                active: event,
            };

            // todo this is actualy update skill tree
            this.axios.post(this.routes.updateSkills(skillTree.id), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        deleteSkillTree(id) {
            this.alert
                .confirm(this.$t('skilltree.delete_set'), this.$t('skilltree.are_you_sure_you_want_to_delete_this_set'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.skillTreeDelete(id)).then(
                            (response) => {
                                ords.use('skillTree').remove(id);

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        showSkillTree(id) {
            window.location.href = this.routes.skillTreeEdit(id);
        },
    },
    mounted() {
        skillTreeOrds.add(this.skillTreesIn);

        ords.use('skillTree')
            .with('las_groups')
            .with('las_main_groups')
            .get()
            .subscribe((skillTrees) => {
                this.skillTrees = skillTrees;
            });

        this.loaded = true;
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    align-items: center;

    button:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
